/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimaryMaterialMounted } from '../../models/primary-material-mounted';

export interface GetInputContainerList$Params {
  workCenterId: number;
}

export function getInputContainerList(http: HttpClient, rootUrl: string, params: GetInputContainerList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrimaryMaterialMounted>>> {
  const rb = new RequestBuilder(rootUrl, getInputContainerList.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PrimaryMaterialMounted>>;
    })
  );
}

getInputContainerList.PATH = '/api/v1/Containers/{workCenterId}/InputContainers';
